import "./Dropdown.css";
import { AiOutlineClose } from "react-icons/ai";

export const Dropdown=({handleClose})=>{
    return (
      <div id="vihari-dropdown-main-wrapper">
        <AiOutlineClose id="vihari-dropdown-close-icon" onClick={handleClose}/>
        <div id="vihari-dropdown-projects-wrap">
          <div id="vihari-dropdown-projects-heading-wrap">
            <div>Projects</div>
            <hr />
          </div>
          <a href="/oryza">
            <div>ORYZA FARMS</div>
          </a>
          <a href="/sreevanam">
            {" "}
            <div>SREE VANAM</div>{" "}
          </a>
          <a href="/aushadha">
            {" "}
            <div>AUSHADHA NAGARI</div>{" "}
          </a>
        </div>
        <div id="vihari-dropdown-menu-wrap">
          <div id="vihari-dropdown-menu-heading-wrap">
            <div>Menu</div>
            <hr />
          </div>
          <a href="/aboutus">
            <div>ABOUT US</div>
          </a>
          <a href="#">
            {" "}
            <div>GALLERY</div>{" "}
          </a>
        </div>
        <div id="vihari-dropdown-contact-wrap">
          <div id="vihari-dropdown-contact-heading-wrap">
            <div>Contact Us</div>
            <hr />
          </div>

          <div>(91) – 8121756666</div>
          <div>(91) – 9294929929</div>
        </div>
        <div id="vihari-dropdown-mail">vihariprojects@gmail.com</div>
        <div id="vihari-dropdown-visit-now-btn-wrap">
          <button id="vihari-dropdown-visit-now-btn">VISIT NOW</button>
        </div>
      </div>
    );
}